import { Form, FormItemProps, Input } from 'antd';
import React from 'react';
import styles from './index.module.scss';

interface IProps {
  name?: string;
  onChange?: (value: string) => void;
  help?: FormItemProps['help'];
  src: string;
  onReset: () => void;
}

const LoginGraphicCapatchaItem: React.FC<IProps> = ({ name = 'graphicCaptcha', src, onReset, onChange, help }) => {
  const validateStatus = help ? 'error' : undefined;

  const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.target.value = e.target.value.replace(/\s/g, '');
    onChange && onChange(e.target.value);
  };

  const onResetClick = () => {
    onReset && onReset();
  };

  if (!src) return <></>;

  return (
    <Form.Item name={name} validateStatus={validateStatus} help={help || undefined} getValueFromEvent={(e) => e.target.value.replace(/\s/g, '')}>
      <div className={styles.graphicCaptcha}>
        <Input size="large" placeholder="图形验证码" onChange={onInputChange} />
        <img onClick={onResetClick} src={src} alt="图形验证码" />
      </div>
    </Form.Item>
  );
};

export default LoginGraphicCapatchaItem;
